/*  ========================================================================
    # Hooks - Use Prefers Reduced Motion
    ========================================================================  */

import { useMemo } from 'react';

const usePrefersReducedMotion = () => {
  const prefersReducedMotion = useMemo(
    () => !window.matchMedia('(prefers-reduced-motion: no-preference)').matches,
    []
  );
  return prefersReducedMotion;
};

export default usePrefersReducedMotion;
